// Generated by scripts/generate-bid-categories.mjs. Do not edit manually.
// Source: Firestore idash_bids/bid_list

export const BID_CATEGORIES = {
  "0002": "Derringer",
  "0003": "Speed And Velocity",
  "0004": "Speed And Velocity",
  "0005": "Engine Performance Air",
  "0006": "Pressure",
  "0007": "Pressure",
  "0008": "Temperature",
  "0009": "Pressure",
  "000A": "Pressure",
  "000B": "Pressure",
  "000C": "Pressure",
  "000D": "Temperature",
  "000E": "Temperature",
  "000F": "Temperature",
  "0010": "Temperature",
  "0011": "Temperature",
  "0012": "Temperature",
  "0013": "Engine Performance Fuel",
  "0014": "Engine Performance Fuel",
  "0015": "Engine Performance Fuel",
  "0016": "Speed And Velocity",
  "0017": "Speed And Velocity",
  "0018": "Transmission",
  "0019": "Transmission",
  "001A": "Transmission",
  "001B": "Transmission",
  "001C": "Vehicle Performance",
  "001D": "Vehicle Performance",
  "001E": "Engine Performance Fuel",
  "001F": "Transmission",
  "0020": "Speed And Velocity",
  "0021": "Engine Performance Fuel",
  "0022": "Temperature",
  "0025": "Derringer",
  "002A": "Vehicle Performance",
  "002B": "Engine Performance Air",
  "002C": "Vehicle Performance",
  "002D": "Diagnostics",
  "002F": "Diagnostics",
  "0031": "Diagnostics",
  "0034": "Fuel Economy",
  "0035": "Diagnostics",
  "0036": "Diagnostics",
  "0049": "Engine Performance Fuel",
  "004A": "Temperature",
  "0058": "Emissions",
  "0059": "Emissions",
  "005B": "Engine Performance Air",
  "005C": "Vehicle Performance",
  "0062": "Vehicle Performance",
  "0064": "Diagnostics",
  "0065": "Engine Performance Air",
  "0066": "Voltage",
  "0067": "Emissions",
  "0068": "Emissions",
  "0069": "Engine Performance Fuel",
  "006A": "Diagnostics",
  "006B": "Temperature",
  "006C": "Pressure",
  "006D": "Vehicle Performance",
  "006E": "Speed And Velocity",
  "006F": "Engine Performance Fuel",
  "0070": "Engine Performance Fuel",
  "0071": "Engine Performance Fuel",
  "0072": "Engine Performance Fuel",
  "0073": "Engine Performance Air",
  "0074": "Engine Performance Air",
  "0075": "Engine Performance Fuel",
  "0076": "Vehicle Performance",
  "0077": "Pressure",
  "0078": "Vehicle Performance",
  "0079": "Pressure",
  "007A": "Pressure",
  "007B": "Pressure",
  "007C": "Pressure",
  "007D": "Vehicle Performance",
  "007E": "Engine Performance Air",
  "007F": "Engine Performance Air",
  "0080": "Engine Performance Fuel",
  "0081": "Pressure",
  "0082": "Pressure",
  "0083": "Speed And Velocity",
  "0084": "Pressure",
  "0085": "Pressure",
  "0086": "Pressure",
  "0087": "Diagnostics",
  "0088": "Temperature",
  "0089": "Temperature",
  "008A": "Temperature",
  "008B": "Temperature",
  "008C": "Speed And Velocity",
  "008D": "Speed And Velocity",
  "008E": "Speed And Velocity",
  "008F": "Speed And Velocity",
  "0090": "Engine Performance Fuel",
  "0091": "Vehicle Performance",
  "0092": "Emissions",
  "0093": "Vehicle Performance",
  "0094": "Vehicle Performance",
  "0095": "Vehicle Performance",
  "00A9": "Temperature",
  "00AA": "Vehicle Performance",
  "00AB": "Emissions",
  "00AD": "Vehicle Performance",
  "00AE": "Vehicle Performance",
  "00AF": "Engine Performance Fuel",
  "00B0": "Engine Performance Fuel",
  "00B1": "Vehicle Performance",
  "00B2": "Emissions",
  "00B3": "Emissions",
  "00B4": "Emissions",
  "00B5": "Engine Performance Fuel",
  "00B6": "Engine Performance Fuel",
  "00B7": "Speed And Velocity",
  "00B8": "Engine Performance Air",
  "00B9": "Engine Performance Air",
  "00BA": "Voltage",
  "00BB": "Transmission",
  "00BC": "Pressure",
  "00BD": "Emissions",
  "00BF": "Air Density",
  "00C1": "Air Density",
  "00C2": "Dynamic",
  "00C3": "Dynamic",
  "00C4": "Dynamic",
  "00C5": "Dynamic",
  "00C6": "Dynamic",
  "00C7": "Dynamic",
  "00C8": "Dynamic",
  "00C9": "Dynamic",
  "00CA": "Dynamic",
  "00CB": "Dynamic",
  "00CC": "Dynamic",
  "00CD": "Dynamic",
  "00CE": "Dynamic",
  "00CF": "Dynamic",
  "00D0": "Dynamic",
  "00D1": "Dynamic",
  "00D2": "Dynamic",
  "00D3": "Dynamic",
  "00D4": "Dynamic",
  "00D5": "Dynamic",
  "00D6": "Air Density",
  "00D7": "Air Density",
  "00DA": "Air Density",
  "00DB": "Air Density",
  "00DC": "Air Density",
  "00DD": "Pressure",
  "00E7": "Air Density",
  "00EB": "Gps And Time",
  "00EC": "Air Density",
  "00ED": "Air Density",
  "0100": "Diagnostics",
  "0101": "Diagnostics",
  "0102": "Engine Performance Air",
  "0103": "Voltage",
  "0104": "Voltage",
  "0105": "Voltage",
  "0106": "Voltage",
  "0107": "Diagnostics",
  "0108": "Pressure",
  "0109": "Engine Performance Fuel",
  "010A": "Voltage",
  "010B": "Engine Performance Fuel",
  "010C": "Voltage",
  "010D": "Engine Performance Fuel",
  "010E": "Voltage",
  "010F": "Engine Performance Fuel",
  "0110": "Voltage",
  "0111": "Emissions",
  "0112": "Emissions",
  "0113": "Diagnostics",
  "0114": "Diagnostics",
  "0115": "Pressure",
  "0116": "Engine Performance Fuel",
  "0117": "Voltage",
  "0118": "Engine Performance Fuel",
  "0119": "Voltage",
  "011A": "Engine Performance Fuel",
  "011B": "Voltage",
  "011C": "Engine Performance Fuel",
  "011D": "Voltage",
  "011E": "Engine Performance Air",
  "011F": "Engine Performance Air",
  "0120": "Vehicle Performance",
  "0121": "Vehicle Performance",
  "0122": "Vehicle Performance",
  "0123": "Engine Performance Air",
  "0124": "Diagnostics",
  "0125": "Diagnostics",
  "0126": "Pressure",
  "0127": "Pressure",
  "0128": "Pressure",
  "0129": "Vehicle Performance",
  "012A": "Vehicle Performance",
  "012B": "Vehicle Performance",
  "012C": "Vehicle Performance",
  "012D": "Engine Performance Air",
  "012E": "Engine Performance Air",
  "012F": "Temperature",
  "0130": "Temperature",
  "0131": "Temperature",
  "0132": "Temperature",
  "0133": "Temperature",
  "0134": "Temperature",
  "0135": "Temperature",
  "0136": "Temperature",
  "0137": "Emissions",
  "0138": "Emissions",
  "0139": "Emissions",
  "013A": "Temperature",
  "013B": "Temperature",
  "013C": "Temperature",
  "013D": "Temperature",
  "013E": "Temperature",
  "013F": "Temperature",
  "0140": "Temperature",
  "0141": "Temperature",
  "0142": "Engine Performance Air",
  "0143": "Engine Performance Air",
  "0144": "Pressure",
  "0145": "Pressure",
  "0146": "Temperature",
  "0147": "Pressure",
  "0148": "Pressure",
  "0149": "Pressure",
  "014A": "Pressure",
  "014B": "Pressure",
  "014C": "Pressure",
  "014D": "Pressure",
  "014E": "Pressure",
  "014F": "Pressure",
  "0150": "Pressure",
  "0151": "Engine Performance Air",
  "0152": "Pressure",
  "0153": "Speed And Velocity",
  "0154": "Temperature",
  "0155": "Temperature",
  "0156": "Temperature",
  "0157": "Temperature",
  "0158": "Temperature",
  "0159": "Temperature",
  "015A": "Temperature",
  "015B": "Temperature",
  "015C": "Temperature",
  "015D": "Temperature",
  "015E": "Temperature",
  "015F": "Temperature",
  "0160": "Temperature",
  "0161": "Temperature",
  "0162": "Temperature",
  "0163": "Temperature",
  "0164": "Temperature",
  "0165": "Temperature",
  "0166": "Temperature",
  "0167": "Temperature",
  "0168": "Pressure",
  "0169": "Pressure",
  "016A": "Pressure",
  "016B": "Pressure",
  "016C": "Pressure",
  "016D": "Temperature",
  "016E": "Temperature",
  "016F": "Temperature",
  "0170": "Temperature",
  "0171": "Diagnostics",
  "0172": "Diagnostics",
  "0173": "Emissions",
  "0174": "Emissions",
  "0175": "Emissions",
  "0176": "Emissions",
  "0177": "Emissions",
  "0178": "Emissions",
  "0179": "Emissions",
  "017A": "Emissions",
  "017B": "Pressure",
  "017C": "Pressure",
  "017D": "Emissions",
  "017E": "Emissions",
  "017F": "Emissions",
  "0180": "Emissions",
  "0181": "Vehicle Performance",
  "0182": "Emissions",
  "0183": "Emissions",
  "0190": "Pressure",
  "0191": "Air Density",
  "0192": "Temperature",
  "0193": "Air Density",
  "0196": "Voltage",
  "0197": "Derringer",
  "0198": "Derringer",
  "01A1": "Vehicle Performance",
  "01A2": "Vehicle Performance",
  "01A5": "Pressure",
  "01A6": "Pressure",
  "01A7": "Engine Performance Fuel",
  "01A8": "Engine Performance Fuel",
  "01A9": "Emissions",
  "01AA": "Emissions",
  "01AB": "Emissions",
  "01AC": "Emissions",
  "01AD": "Emissions",
  "01AE": "Emissions",
  "01AF": "Emissions",
  "01B0": "Emissions",
  "01B1": "Emissions",
  "01B2": "Emissions",
  "01B3": "Emissions",
  "01B4": "Emissions",
  "01B5": "Emissions",
  "01B6": "Emissions",
  "01B7": "Emissions",
  "01B8": "Emissions",
  "01B9": "Dynamic",
  "01BA": "Dynamic",
  "01BB": "Dynamic",
  "01BC": "Dynamic",
  "01BD": "Temperature",
  "01BE": "Temperature",
  "01BF": "Temperature",
  "01C0": "Temperature",
  "01C1": "Temperature",
  "01C2": "Temperature",
  "01C3": "Temperature",
  "01C4": "Temperature",
  "01C5": "Air Density",
  "01C6": "Engine Performance Fuel",
  "01C7": "Temperature",
  "01C8": "Temperature",
  "01C9": "Temperature",
  "01CA": "Temperature",
  "01CB": "Temperature",
  "01CC": "Temperature",
  "01CD": "Temperature",
  "01CE": "Temperature",
  "01CF": "Pressure",
  "01D0": "Temperature",
  "01D1": "Air Density",
  "01D2": "Air Density",
  "01D3": "Pressure",
  "01D4": "Temperature",
  "01D5": "Air Density",
  "01D6": "Air Density",
  "01D7": "Pressure",
  "01D8": "Temperature",
  "01D9": "Air Density",
  "01DA": "Air Density",
  "01DB": "Pressure",
  "01DC": "Temperature",
  "01DD": "Air Density",
  "01DE": "Air Density",
  "01DF": "Pressure",
  "01E0": "Temperature",
  "01E1": "Air Density",
  "01E2": "Air Density",
  "01E3": "Pressure",
  "01E4": "Temperature",
  "01E5": "Air Density",
  "01E6": "Air Density",
  "01E7": "Pressure",
  "01E8": "Temperature",
  "01E9": "Air Density",
  "01EA": "Air Density",
  "01EB": "Pressure",
  "01EC": "Temperature",
  "01ED": "Air Density",
  "01EE": "Air Density",
  "01EF": "Temperature",
  "01F0": "Engine Performance Air",
  "01F1": "Engine Performance Air",
  "01F4": "Engine Performance Air",
  "01F5": "Engine Performance Air",
  "01F6": "Pressure",
  "01F7": "Engine Performance Air",
  "01F8": "Engine Performance Air",
  "01FC": "Pressure",
  "01FD": "Pressure",
  "01FE": "Pressure",
  "01FF": "Pressure",
  "0200": "Pressure",
  "0201": "Air Density",
  "0202": "Air Density",
  "0203": "Air Density",
  "0204": "Air Density",
  "0205": "Air Density",
  "0206": "Temperature",
  "0207": "Pressure",
  "0208": "Temperature",
  "0209": "Air Density",
  "020A": "Air Density",
  "020F": "Engine Performance Air",
  "0213": "Pressure",
  "0214": "Pressure",
  "0216": "Derringer",
  "0217": "Vehicle Performance",
  "0218": "Vehicle Performance",
  "0219": "Vehicle Performance",
  "021A": "Vehicle Performance",
  "021B": "Vehicle Performance",
  "021C": "Vehicle Performance",
  "021D": "Vehicle Performance",
  "021E": "Vehicle Performance",
  "0226": "Pressure",
  "0228": "Pressure",
  "0229": "Pressure",
  "022A": "Pressure",
  "022B": "Diagnostics",
  "022F": "Engine Performance Fuel",
  "0230": "Engine Performance Fuel",
  "0231": "Engine Performance Fuel",
  "0232": "Vehicle Performance",
  "0233": "Vehicle Performance",
  "0234": "Vehicle Performance",
  "0235": "Vehicle Performance",
  "0236": "Vehicle Performance",
  "0237": "Vehicle Performance",
  "0238": "Vehicle Performance",
  "0239": "Vehicle Performance",
  "023A": "Vehicle Performance",
  "023B": "Diagnostics",
  "023C": "Vehicle Performance",
  "023D": "Vehicle Performance",
  "023E": "Vehicle Performance",
  "023F": "Engine Performance Fuel",
  "0240": "Vehicle Performance",
  "0241": "Vehicle Performance",
  "0242": "Vehicle Performance",
  "0243": "Engine Performance Fuel",
  "0244": "Engine Performance Fuel",
  "0245": "Engine Performance Fuel",
  "0246": "Engine Performance Air",
  "0247": "Pressure",
  "0248": "Engine Performance Fuel",
  "0249": "Engine Performance Air",
  "024A": "Engine Performance Air",
  "024B": "Engine Performance Air",
  "024C": "Engine Performance Air",
  "024D": "Engine Performance Air",
  "024E": "Temperature",
  "024F": "Temperature",
  "0250": "Temperature",
  "0251": "Temperature",
  "0252": "Temperature",
  "0253": "Temperature",
  "0254": "Temperature",
  "0255": "Temperature",
  "025C": "Temperature",
  "025E": "Temperature",
  "0264": "Engine Performance Fuel",
  "0265": "Engine Performance Fuel",
  "0266": "Engine Performance Fuel",
  "0267": "Engine Performance Fuel",
  "0268": "Engine Performance Fuel",
  "0269": "Engine Performance Fuel",
  "026A": "Engine Performance Fuel",
  "026B": "Pressure",
  "026C": "Engine Performance Fuel",
  "026D": "Dynamic",
  "026E": "Dynamic",
  "026F": "Dynamic",
  "0270": "Dynamic",
  "0271": "Dynamic",
  "0272": "Dynamic",
  "0273": "Air Density",
  "0274": "Air Density",
  "0275": "Air Density",
  "0276": "Pressure",
  "0277": "Temperature",
  "0278": "Emissions",
  "027C": "Vehicle Performance",
  "027D": "Vehicle Performance",
  "027E": "Vehicle Performance",
  "027F": "Vehicle Performance",
  "0280": "Vehicle Performance",
  "0281": "Vehicle Performance",
  "0288": "Transmission",
  "0289": "Air Density",
  "028A": "Speed And Velocity",
  "028D": "Engine Performance Fuel",
  "028E": "Engine Performance Fuel",
  "028F": "Engine Performance Fuel",
  "0290": "Engine Performance Fuel",
  "0291": "Engine Performance Fuel",
  "0292": "Engine Performance Fuel",
  "0293": "Engine Performance Fuel",
  "0294": "Engine Performance Fuel",
  "0295": "Engine Performance Fuel",
  "029C": "Transmission",
  "029D": "Transmission",
  "029E": "Engine Performance Fuel",
  "029F": "Engine Performance Fuel",
  "02A2": "Air Density",
  "02A3": "Air Density",
  "02A4": "Pressure",
  "02AA": "Engine Performance Fuel",
  "02B2": "Temperature",
  "02B4": "Vehicle Performance",
  "02B5": "Vehicle Performance",
  "02B6": "Vehicle Performance",
  "02B7": "Vehicle Performance",
  "02B8": "Vehicle Performance",
  "02B9": "Temperature",
  "02BA": "Temperature",
  "02BB": "Engine Performance Air",
  "02BC": "Vehicle Performance",
  "02BF": "Pressure",
  "02C0": "Temperature",
  "02C1": "Air Density",
  "02C2": "Air Density",
  "02C3": "Derringer",
  "02C4": "Temperature",
  "02C5": "Pressure",
  "02C6": "Pressure",
  "02C7": "Pressure",
  "02C8": "Pressure",
  "02C9": "Pressure",
  "02CA": "Pressure",
  "02CB": "Temperature",
  "02CC": "Temperature",
  "02CD": "Temperature",
  "02CE": "Temperature",
  "02CF": "Pressure",
  "02D0": "Temperature",
  "02D1": "Pressure",
  "02D2": "Temperature",
  "02D3": "Temperature",
  "02D4": "Pressure",
  "02D5": "Pressure",
  "02D8": "Pressure",
  "02D9": "Pressure",
  "02DA": "Pressure",
  "02DB": "Temperature",
  "02DC": "Air Density",
  "02DD": "Air Density",
  "02DE": "Pressure",
  "02DF": "Air Density",
  "02E2": "Vehicle Performance",
  "02E3": "Vehicle Performance",
  "02E4": "Engine Performance Air",
  "02E5": "Engine Performance Air",
  "02E6": "Engine Performance Air",
  "02E7": "Engine Performance Air",
  "02E8": "Vehicle Performance",
  "02E9": "Vehicle Performance",
  "02EA": "Vehicle Performance",
  "02EB": "Vehicle Performance",
  "02EC": "Vehicle Performance",
  "02ED": "Vehicle Performance",
  "02EE": "Temperature",
  "02EF": "Temperature",
  "02F0": "Temperature",
  "02F1": "Temperature",
  "02F2": "Temperature",
  "02F3": "Temperature",
  "02F4": "Temperature",
  "02F5": "Temperature",
  "02F6": "Temperature",
  "02F7": "Temperature",
  "02F8": "Temperature",
  "02F9": "Temperature",
  "02FA": "Temperature",
  "02FB": "Pressure",
  "02FC": "Pressure",
  "02FD": "Pressure",
  "02FE": "Temperature",
  "02FF": "Vehicle Performance",
  "0300": "Pressure",
  "0301": "Pressure",
  "0302": "Pressure",
  "0303": "Temperature",
  "0304": "Temperature",
  "0308": "Pressure",
  "0309": "Engine Performance Air",
  "030A": "Engine Performance Air",
  "030B": "Pressure",
  "030C": "Pressure",
  "030D": "Pressure",
  "030E": "Temperature",
  "030F": "Temperature",
  "0311": "Pedal Monster",
  "0312": "Pedal Monster",
  "0313": "Engine Performance Fuel",
  "0314": "Engine Performance Fuel",
  "0315": "Temperature",
  "0316": "Temperature",
  "0317": "Temperature",
  "0318": "Temperature",
  "0319": "Temperature",
  "031A": "Temperature",
  "031B": "Temperature",
  "031C": "Temperature",
  "031D": "Emissions",
  "031E": "Emissions",
  "031F": "Emissions",
  "0320": "Emissions",
  "0321": "Emissions",
  "0322": "Emissions",
  "0323": "Emissions",
  "0324": "Engine Performance Fuel",
  "0325": "Engine Performance Fuel",
  "0328": "Engine Performance Air",
  "0329": "Pressure",
  "032A": "Pedal Monster",
  "032B": "Pedal Monster",
  "032C": "Pedal Monster",
  "032D": "Engine Performance Air",
  "0330": "Pressure",
  "0331": "Temperature",
  "0332": "Air Density",
  "0333": "Air Density",
  "0334": "Emissions",
  "0337": "Temperature",
  "033A": "Pressure",
  "033B": "Temperature",
  "033C": "Air Density",
  "033D": "Air Density",
  "033E": "Pressure",
  "033F": "Temperature",
  "0340": "Air Density",
  "0341": "Air Density",
  "0342": "Engine Performance Air",
  "0343": "Engine Performance Air",
  "0344": "Pedal Monster",
  "0345": "Pressure",
  "0346": "Engine Performance Fuel",
  "0347": "Engine Performance Fuel",
  "0348": "Engine Performance Fuel",
  "0349": "Engine Performance Fuel",
  "034A": "Engine Performance Fuel",
  "034B": "Engine Performance Fuel",
  "034D": "Pressure",
  "034E": "Temperature",
  "034F": "Air Density",
  "0350": "Air Density",
  "0351": "Pressure",
  "0352": "Air Density",
  "0353": "Pressure",
  "0354": "Temperature",
  "0357": "Pedal Monster",
  "0358": "Pedal Monster",
  "035A": "Engine Performance Air",
  "035B": "Engine Performance Air",
  "035C": "Vehicle Performance",
  "035D": "Temperature",
  "0360": "Diagnostics",
  "0362": "Engine Performance Fuel",
  "0363": "Engine Performance Fuel",
  "0364": "Engine Performance Fuel",
  "0365": "Engine Performance Fuel",
  "0366": "Vehicle Performance",
  "0367": "Vehicle Performance",
  "0368": "Vehicle Performance",
  "0369": "Vehicle Performance",
  "036A": "Vehicle Performance",
  "036B": "Vehicle Performance",
  "0390": "Vehicle Performance",
  "0391": "Gps And Time",
  "0392": "Gps And Time",
  "0393": "Pressure",
  "0394": "Engine Performance Fuel",
  "0395": "Vehicle Performance",
  "0396": "Vehicle Performance",
  "0397": "Vehicle Performance",
  "0398": "Vehicle Performance",
  "0399": "Vehicle Performance",
  "039A": "Vehicle Performance",
  "039B": "Pressure",
  "039C": "Pressure",
  "039D": "Pressure",
  "039E": "Pressure",
  "039F": "Temperature"
} as const;

export const BID_CATEGORY_ORDER = [
  "Air Density",
  "Derringer",
  "Diagnostics",
  "Dynamic",
  "Emissions",
  "Engine Performance Air",
  "Engine Performance Fuel",
  "Fuel Economy",
  "Gps And Time",
  "Pedal Monster",
  "Pressure",
  "Speed And Velocity",
  "Temperature",
  "Transmission",
  "Vehicle Performance",
  "Voltage"
] as const;
